import { cn } from '../../lib/utils';

export const StatusBadge = ({ status, className }) => {
  const statusConfig = {
    // Candidate statuses
    new: { label: 'New', class: 'status-new' },
    screening: { label: 'Screening', class: 'status-screening' },
    interview: { label: 'Interview', class: 'status-interview' },
    offered: { label: 'Offered', class: 'status-offered' },
    hired: { label: 'Hired', class: 'status-hired' },
    rejected: { label: 'Rejected', class: 'status-rejected' },
    'on-hold': { label: 'On Hold', class: 'status-onhold' },
    // Job statuses
    open: { label: 'Open', class: 'status-open' },
    draft: { label: 'Draft', class: 'status-draft' },
    closed: { label: 'Closed', class: 'status-closed' },
    filled: { label: 'Filled', class: 'status-filled' },
  };

  const config = statusConfig[status?.toLowerCase()] || { label: status || 'Unknown', class: 'badge-neutral' };

  return (
    <span className={cn('badge', config.class, className)}>
      {config.label}
    </span>
  );
};

export const PriorityBadge = ({ priority, className }) => {
  const priorityConfig = {
    urgent: { label: 'Urgent', class: 'priority-urgent' },
    high: { label: 'High', class: 'priority-high' },
    medium: { label: 'Medium', class: 'priority-medium' },
    low: { label: 'Low', class: 'priority-low' },
  };

  const config = priorityConfig[priority?.toLowerCase()] || { label: priority || 'Medium', class: 'priority-medium' };

  return (
    <span className={cn('badge', config.class, className)}>
      {config.label}
    </span>
  );
};

export const ScoreBadge = ({ score, showLabel = true, className }) => {
  let config;
  if (score >= 85) {
    config = { label: 'Excellent', class: 'score-excellent' };
  } else if (score >= 70) {
    config = { label: 'Good', class: 'score-good' };
  } else if (score >= 50) {
    config = { label: 'Average', class: 'score-average' };
  } else {
    config = { label: 'Poor', class: 'score-poor' };
  }

  return (
    <span className={cn('badge border', config.class, className)}>
      {score?.toFixed(0)}%{showLabel && ` - ${config.label}`}
    </span>
  );
};

export const RoleBadge = ({ role, className }) => {
  const roleConfig = {
    super_admin: { label: 'Super Admin', class: 'bg-purple-50 text-purple-700 border border-purple-200' },
    admin: { label: 'Admin', class: 'bg-blue-50 text-blue-700 border border-blue-200' },
    hr_manager: { label: 'HR Manager', class: 'bg-cyan-50 text-cyan-700 border border-cyan-200' },
    recruiter: { label: 'Recruiter', class: 'bg-slate-100 text-slate-700 border border-slate-200' },
  };

  const config = roleConfig[role] || { label: role || 'Unknown', class: 'badge-neutral' };

  return (
    <span className={cn('badge', config.class, className)}>
      {config.label}
    </span>
  );
};

export const SkillTag = ({ skill, matched, missing, className }) => {
  let tagClass = 'skill-tag';
  if (matched) tagClass += ' skill-tag-match';
  if (missing) tagClass += ' skill-tag-missing';

  return (
    <span className={cn(tagClass, className)}>
      {skill}
    </span>
  );
};
